import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SharedDataService } from '../app/shared-data.service';
import { HttpClient } from '@angular/common/http';
import { Http, RequestOptions } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class FileService {
 private fileList: string[] = new Array<string>();
 public fileList$: Subject<string[]> = new Subject<string[]>();
 private displayLoader$: Subject<boolean> = new BehaviorSubject<boolean>(false);
 public links = [];

 constructor(
   private httpc: HttpClient,
   private http: Http,
   private requestOptions: RequestOptions,
   public sharedDataService: SharedDataService,
  ) { 
    this.requestOptions = this.sharedDataService.returnRequestOptions2();
  }

  public isLoading(): Observable<boolean> {
    return this.displayLoader$;
  }

 public upload(fd, fileArrayList): void {
    this.links = [];
    // working post
    // let url = 'https://dev.infoviewsims.com/upload_multimedia';
    let url = 'https://dev.infoviewsims.com/mtn_smpp';
    this.startTimer();
    this.http.post(url, fd, this.requestOptions).subscribe(
      (res) => {
        this.pauseTimer();
        this.links = res.json();
      },
      (err) => {
        this.pauseTimer();
        this.timeLeft = 0;
        this.sharedDataService.celebrate("Unable to Upload File","Ok");
      }
    );

    fileArrayList.forEach(element => {
      this.fileList.push(element.file_name);
    });
   this.fileList$.next(this.fileList);
 }

 public download(fileName: string): void {

 }

 public fileChange(event) {
  let fileList: FileList = event.target.files;
  if(fileList.length > 0) {
    let formData :FormData = new FormData();
    for (var i = 0; i < fileList.length; i++) {
      formData.append('file', fileList[i]);    
    }
    // let url = 'https://dev.infoviewsims.com/mtn_smpp';
    let url = 'https://dev.infoviewsims.com/upload_multimedia';
    this.http.post(url, formData, this.requestOptions).subscribe(
      (res) => {
        this.links = res.json();
      },
      (err) => {
        
      }
    );
  }
  }

 timeLeft: number = 0;
 interval;

startTimer() {
   this.interval = setInterval(() => {
     if(this.timeLeft < 60) {
       this.timeLeft++;
     } else {
       this.timeLeft = 60;
     }
   },1000)
 }

 pauseTimer() {
   clearInterval(this.interval);
 }

 public remove(fileName): void {
   this.fileList.splice(this.fileList.findIndex(name => name === fileName), 1);
   this.fileList$.next(this.fileList);
 }

 public list(): Observable<string[]> {
   return this.fileList$;
 }

 private addFileToList(fileName: string): void {
   this.fileList.push(fileName);
   this.fileList$.next(this.fileList);
 }

//  this.http.post(url,{name: fileName, content: fileContent})
//  .pipe(finalize(() => this.displayLoader$.next(false))).subscribe(
//    (res) => {
//      this.fileList.push(fileName);
//      this.fileList$.next(this.fileList);
//    }, error => {
//      this.displayLoader$.next(false);
//    }
//  );

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/file.service.ts